import SideFooter from "components/header-footer/SideFooter"
import { useEffect, useState } from "react"

export default function CookieDeclaration() {
  const [cookiebotloaded, setCookiebotloaded] = useState(false)
  useEffect(() => {
    if (!cookiebotloaded) {
      const script = document.createElement("script")
      script.src = "https://consent.cookiebot.com/efb02f08-19a2-4c4c-859b-13ad1997c3ce/cd.js"
      script.id = "CookieDeclaration"
      script.async = true
      script.onload = () => setCookiebotloaded(true)

      document.getElementById("cd")?.appendChild(script)
    }
  }, [])

  return (
    <>
      <div id="cd" style={{ margin: "5rem" }}>
        <h2>Cookie Erklärung</h2>
      </div>
      <SideFooter />
    </>
  )
}
